import React from "react";
import {
  useProjectStatusCreation,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { Form } from "./form";
import { Routes } from "./switch";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectStatusCreation(_: Props) {
  const { planzone } = useRetrieveCurrentPlanzone();
  const { isRequestPending, createProjectStatus } = useProjectStatusCreation();

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) =>
        isVisible ? (
          <Form
            submit={(status) => {
              if (!isRequestPending) {
                createProjectStatus({ status, planzone });
                hide();
              }
            }}
          />
        ) : (
          <div className={styles.switch}>
            <Routes switch={show} />
          </div>
        )
      }
    </VisibilityWatcher>
  );
}

export { ProjectStatusCreation };
